import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_ROWS = "getPaginatedRows";
export const ALL_ROWS = "getAllRows";
export const CREATE_ROW_FORM = "createRowForm";
export const DELETE_ROW = "deleteRow";
export const GET_ROW_DATA = "getRowData";
export const CREATE_ROW = "createRow";
export const UPDATE_ROW = "updateRow";


// mutation types

export const SET_PAGINATED_ROWS = "setPaginatedRows";
export const SET_ALL_ROWS = "setAllRows";
export const SET_ROW_DATA = "setRowData";
export const SET_ROW_META = "setRowMeta";
export const SET_ROW_ERROR = "setRowError";
export const SET_ROW_LOADING = "setRowLoading";
export const CLEAR_ROW_ERROR = "clearRowError";
export const SET_IS_DISABLED_ROW = "setIsDisabledRow";


const state = {
    rows: [],
    paginatedRows: [],
    row_data: {},
    meta_row : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllRows(state) {
        return state.paginatedRows;
    },

    allRows(state) {
        return state.rows;
    },

    getRowData(state) {
        return state.row_data;
    },

    meta_row(state) {
        return state.meta_row;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_ROWS](context, payload) {
        context.commit(SET_IS_DISABLED_ROW, false);
        context.commit(SET_ROW_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/rows?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_ROW_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_ROWS, data);
                context.commit(SET_ROW_META, data);
                context.commit(SET_ROW_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_ROW_LOADING, false);
            context.commit(SET_ROW_ERROR, response.errors);
        });
        ;
        
    },

    [ALL_ROWS]() {
        return new Promise(resolve => {
            ApiService.get('/rowsAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_ROW_FORM](context) {
        context.commit(SET_ROW_LOADING, false);
        context.commit(SET_ROW_ERROR, false);
        context.commit(SET_IS_DISABLED_ROW, false);
    },

    [GET_ROW_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_ROW, true);
        context.commit(SET_ROW_LOADING, true);
        context.commit(CLEAR_ROW_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/row/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_ROW_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_ROW_DATA, response.data);
                    context.commit(SET_ROW_LOADING, false);
                    context.commit(SET_IS_DISABLED_ROW, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_ROW_LOADING, false);
                context.commit(SET_ROW_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_ROW, true);
            });
        });
    },

    [CREATE_ROW](context, payload) {
        context.commit(SET_ROW_LOADING, false);
        context.commit(SET_IS_DISABLED_ROW, true);
        context.commit(CLEAR_ROW_ERROR);
        return ApiService.post("/row/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_ROW_ERROR);
            }
            else{
                context.commit(SET_ROW_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Sıra başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_ROW_ERROR);
                context.commit(SET_IS_DISABLED_ROW, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_ROW_LOADING, false);
            context.commit(SET_ROW_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_ROW, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_ROW](context, payload) {
        context.commit(SET_ROW_LOADING, true);
        context.commit(SET_IS_DISABLED_ROW, true);
        context.commit(CLEAR_ROW_ERROR);
        
        return ApiService.put(`/row/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_ROW_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı sıra başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_ROW, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_ROW_LOADING, false);
            context.commit(SET_ROW_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_ROW, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_ROW](context, payload) {
        context.commit(SET_ROW_LOADING, true);
        context.commit(CLEAR_ROW_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/row/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_ROW_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else {
                
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı sıra başarıyla silinmiştir."
                );
                
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_ROW_ERROR, error);
            AlertService.makeToast(
                "warning",
                "Hata!",
                error
            );
        });
        
    },

    
    
};

const mutations = {

    [SET_PAGINATED_ROWS](state, paginatedRows) {
        state.paginatedRows = paginatedRows.data;
    },

    [SET_ALL_ROWS](state, rows) {
        state.rows = rows;
    },

    [SET_ROW_DATA](state, rows_data) {
        state.rows_data = rows_data;
        state.errors = [];
    },

    [SET_ROW_META](state, meta_row) {
        state.meta_row = meta_row;
    },

    [SET_ROW_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_ROW_ERROR](state) {
        state.errors = [];
    },
    
    [SET_ROW_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_ROW](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
